import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Informationen")
const _hoisted_2 = { class: "ion-padding-bottom" }
const _hoisted_3 = {
  key: 0,
  class: "ion-padding-bottom"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("b", null, "Idee und Konzeption die dahinter steckt:", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "ion-padding-bottom"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("b", null, "Design, Funktionalität, Kreativität, etc.:", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "ion-padding-bottom"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("b", null, "Herstellungsweise:", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 3,
  class: "ion-padding-bottom"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("b", null, "Rezeptur:", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 4,
  class: "ion-padding-bottom"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("b", null, "Geschmack:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = {
  key: 5,
  class: "ion-padding-bottom"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("b", null, " Besondere Vorteile für den Lebensmittelhandel:", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 6,
  class: "ion-padding-bottom"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("b", null, "Besondere Vorteile für den Konsumenten:", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Bewertung")
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, "Legende", -1)
const _hoisted_26 = { class: "vote-container" }
const _hoisted_27 = { class: "legend" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "= gar nicht zutreffend", -1)
const _hoisted_29 = { class: "legend" }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, "= neutral", -1)
const _hoisted_31 = { class: "legend" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "= voll zutreffend", -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode("1. Idee und Konzept hinter dieser Produktneuheit ")
const _hoisted_34 = { class: "ion-padding-vertical" }
const _hoisted_35 = {
  key: 0,
  class: "color-grey vote"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode("2. Das Produkt ist als Innovation erkennbar und verdient diesen \"Titel\" ")
const _hoisted_37 = {
  ref: 'rating'+8,
  class: "vote-container rating-container"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "color-grey vote" }, "-", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "votes hidden" }, [
  /*#__PURE__*/_createVNode("div", { class: "vote" }, "-")
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "votes hidden" }, [
  /*#__PURE__*/_createVNode("div", { class: "vote" }, "-")
], -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Kommentar ")
const _hoisted_42 = /*#__PURE__*/_createVNode("p", null, "Bitte begründen Sie Ihre Bewertung", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header danger" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("h6", null, "Fehlende Angaben", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Bewertung bei ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" ist leer.")
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Bewertung bei ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" ist leer.")
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("p", null, "Bitte füllen Sie die fehlenden Punkte aus.", -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Abschließen")
const _hoisted_54 = /*#__PURE__*/_createVNode("p", null, "Sie haben nochmal die Möglichkeit Ihre Bewertung zu überprüfen.", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Speichern ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_ion_loading = _resolveComponent("ion-loading")
  const _component_ion_card_title = _resolveComponent("ion-card-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_textarea = _resolveComponent("ion-textarea")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_IonCol = _resolveComponent("IonCol")
  const _component_IonRow = _resolveComponent("IonRow")
  const _component_IonGrid = _resolveComponent("IonGrid")
  const _component_IonContent = _resolveComponent("IonContent")
  const _component_IonPage = _resolveComponent("IonPage")

  return (_openBlock(), _createBlock(_component_IonPage, null, {
    default: _withCtx(() => [
      _createVNode(_component_Header, { back: true }),
      _createVNode(_component_IonContent, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_loading, {
            backdropDismiss: false,
            "is-open": _ctx.isCurrentlyLoading,
            message: "Speichern..."
          }, null, 8, ["is-open"]),
          _createVNode(_component_IonGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_IonRow, { class: "ion-justify-content-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonCol, { class: "ion-text-center ion-padding ion-margin" }, {
                    default: _withCtx(() => [
                      (_ctx.getCheeseInfos?.benefitDistributor || _ctx.getCheeseInfos?.benefitConsumer || _ctx.getCheeseInfos?.concept
                                    || _ctx.getCheeseInfos?.look || _ctx.getCheeseInfos?.productionMethod || _ctx.getCheeseInfos?.recipe || _ctx.getCheeseInfos?.taste)
                        ? (_openBlock(), _createBlock(_component_ion_card, {
                            key: 0,
                            class: "ion-padding",
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, { class: "small" }, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createVNode("p", _hoisted_2, _toDisplayString(_ctx.getCheeseInfos?.productInfoString()), 1),
                                  (_ctx.getCheeseInfos?.concept)
                                    ? (_openBlock(), _createBlock("p", _hoisted_3, [
                                        _hoisted_4,
                                        _hoisted_5,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.concept), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getCheeseInfos?.look)
                                    ? (_openBlock(), _createBlock("p", _hoisted_6, [
                                        _hoisted_7,
                                        _hoisted_8,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.look), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getCheeseInfos?.productionMethod)
                                    ? (_openBlock(), _createBlock("p", _hoisted_9, [
                                        _hoisted_10,
                                        _hoisted_11,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.productionMethod), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getCheeseInfos?.recipe)
                                    ? (_openBlock(), _createBlock("p", _hoisted_12, [
                                        _hoisted_13,
                                        _hoisted_14,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.recipe), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getCheeseInfos?.taste)
                                    ? (_openBlock(), _createBlock("p", _hoisted_15, [
                                        _hoisted_16,
                                        _hoisted_17,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.taste), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getCheeseInfos?.benefitDistributor)
                                    ? (_openBlock(), _createBlock("p", _hoisted_18, [
                                        _hoisted_19,
                                        _hoisted_20,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.benefitDistributor), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getCheeseInfos?.benefitConsumer)
                                    ? (_openBlock(), _createBlock("p", _hoisted_21, [
                                        _hoisted_22,
                                        _hoisted_23,
                                        _createTextVNode(" " + _toDisplayString(_ctx.getCheeseInfos?.benefitConsumer), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_card, { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_content, { class: "ion-text-left" }, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              _createVNode("div", _hoisted_26, [
                                _createVNode("div", _hoisted_27, [
                                  _createVNode("div", {
                                    class: ['color-'+1, "vote"]
                                  }, "1"),
                                  _hoisted_28
                                ]),
                                _createVNode("div", _hoisted_29, [
                                  _createVNode("div", {
                                    class: ['color-'+3, "vote"]
                                  }, "3"),
                                  _hoisted_30
                                ]),
                                _createVNode("div", _hoisted_31, [
                                  _createVNode("div", {
                                    class: ['color-'+6, "vote"]
                                  }, "5"),
                                  _hoisted_32
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-text-left ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small ion-text-center" }, {
                                default: _withCtx(() => [
                                  _hoisted_33
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ratings, (rating, index) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: index,
                                  class: "ion-padding-vertical ion-margin-vertical"
                                }, [
                                  _createVNode("p", _hoisted_34, _toDisplayString(rating.title), 1),
                                  _createVNode("div", {
                                    ref: 'rating'+index,
                                    class: "vote-container rating-container"
                                  }, [
                                    (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
                                      return _createVNode("div", {
                                        key: i,
                                        class: "votes ",
                                        onClick: ($event: any) => (_ctx.setVote(index,i))
                                      }, [
                                        (i===1)
                                          ? (_openBlock(), _createBlock("div", _hoisted_35, "-"))
                                          : (_openBlock(), _createBlock("div", {
                                              key: 1,
                                              class: ['color-'+(i-1), "vote"]
                                            }, _toDisplayString((i - 1)), 3))
                                      ], 8, ["onClick"])
                                    }), 64))
                                  ], 512)
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-text-left ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small ion-text-center" }, {
                                default: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode("div", _hoisted_37, [
                                _createVNode("div", {
                                  class: "votes ",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVote(8,1)))
                                }, [
                                  _hoisted_38
                                ]),
                                _createVNode("div", {
                                  class: "votes ",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setVote(8,2)))
                                }, [
                                  _createVNode("div", {
                                    class: ['color-'+(2-1), "vote"]
                                  }, "Nein", 2)
                                ]),
                                _hoisted_39,
                                _createVNode("div", {
                                  class: "votes ",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setVote(8,4)))
                                }, [
                                  _createVNode("div", {
                                    class: ['color-'+(4-1), "vote small"]
                                  }, "Eher nicht", 2)
                                ]),
                                _hoisted_40,
                                _createVNode("div", {
                                  class: "votes ",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setVote(8,6)))
                                }, [
                                  _createVNode("div", {
                                    class: ['color-'+(6-1), "vote"]
                                  }, "Ja", 2)
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_card, {
                        class: "ion-padding",
                        color: "light"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, { class: "small" }, {
                                default: _withCtx(() => [
                                  _hoisted_41,
                                  _createVNode("span", { style: { color: 'var(--ion-color-danger)' } }, "*", 4)
                                ]),
                                _: 1
                              }),
                              _hoisted_42
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_textarea, {
                                ref: "comment",
                                modelValue: _ctx.commentInnovation,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.commentInnovation = $event)),
                                placeholder: "Text eingeben...",
                                required: true,
                                onChange: _ctx.setComment
                              }, null, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.error.show)
                        ? (_openBlock(), _createBlock(_component_ion_card, {
                            key: 1,
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_43,
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _hoisted_44
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, { class: "danger-text" }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ratings, (err, index) => {
                                    return (_openBlock(), _createBlock("ul", { key: index }, [
                                      (err.value)
                                        ? (_openBlock(), _createBlock("li", _hoisted_45, [
                                            _hoisted_46,
                                            _createVNode("strong", null, "\"" + _toDisplayString(err.title) + "\"", 1),
                                            _hoisted_47
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.error, (err, index) => {
                                    return (_openBlock(), _createBlock("ul", { key: index }, [
                                      (err.value)
                                        ? (_openBlock(), _createBlock("li", _hoisted_48, [
                                            _hoisted_49,
                                            _createVNode("strong", null, "\"" + _toDisplayString(err.lable) + "\"", 1),
                                            _hoisted_50
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  _hoisted_51,
                                  _hoisted_52
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_card, { color: "light" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card_header, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_title, null, {
                                default: _withCtx(() => [
                                  _hoisted_53
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              _hoisted_54,
                              _createVNode(_component_ion_button, {
                                class: "ion-margin",
                                expand: "block",
                                disabled: _ctx.commentInnovation?.length === 0,
                                onClick: _ctx.showVerifyModal
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_55
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}